import config from '@config';
import React from 'react';
import { FunctionComponent } from 'react';

interface HomePageMenuItemCompProps
{
    menuItem: HomePageMenuItem;
}

const HomePageMenuItemComp: FunctionComponent<HomePageMenuItemCompProps> = (props) =>
{
    /** Render */
    return (
        <div className="home-page-menu-item">
            <a href={config.appUrl + props.menuItem.url}>
                <div className={'home-page-menu-item--name ' + (props.menuItem.isPromoted ? 'promoted' : '')}>
                    {props.menuItem.name}
                </div>
            </a>
        </div>
    );
}


export type HomePageMenuItem = {
    name: string;
    url: string;
    isPromoted?: boolean;
};

export default HomePageMenuItemComp;